import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-replies-list',
  templateUrl: './replies-list.component.html',
  styleUrls: ['./replies-list.component.scss'],
  providers: [AngularFireDatabase]
})
export class RepliesListComponent implements OnInit {
  @Input() forumId : string;
  replies: Observable<any[]>;

  constructor(private db: AngularFireDatabase) { }

  ngOnInit() {
    let itemsRef = this.db.list('replies/', ref => ref.orderByChild('forumId').equalTo(this.forumId));
    this.replies = itemsRef.valueChanges().map( changes => {
      return changes.filter(it => ! Object.hasOwnProperty('inactive'))
    });
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/replies/replies-list/replies-list.component.ts